const COLORS = { green: "#1B7F3B", amber: "#D97706", red: "#BB162B", blue: "#1E5AA8" };

const LEGEND = [
  ["green", "≥95% filled"],
  ["amber", "85–95%"],
  ["red", "<85% — critical"],
  ["blue", "Over-manned"],
];

export default function HeatMapGrid({ data, onDrill }) {
  if (!data)
    return <div className="h-64 bg-white border border-gray-200 rounded-sm animate-pulse" data-testid="heatmap-loading" />;
  const { branches, departments, cells } = data;
  return (
    <div>
      <div className="overflow-auto max-h-[520px] border border-gray-200 rounded-sm bg-white" data-testid="heatmap-grid">
        <table className="border-collapse">
          <thead>
            <tr>
              <th className="sticky top-0 left-0 z-30 bg-white text-left text-[10px] uppercase tracking-wider text-[#6B7280] px-2 py-1 border-b border-r border-gray-200 align-bottom">
                Branch
              </th>
              {departments.map((d) => (
                <th key={d.dept_id} className="sticky top-0 z-20 bg-white px-0.5 pt-2 pb-1 border-b border-gray-200 align-bottom">
                  <div
                    style={{ writingMode: "vertical-rl", transform: "rotate(180deg)" }}
                    className="mx-auto h-24 text-[9px] font-medium text-[#6B7280] whitespace-nowrap"
                    title={d.dept_name}
                  >
                    {d.dept_name}
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {branches.map((b) => (
              <tr key={b.branch_id}>
                <td className="sticky left-0 z-10 bg-white pl-2 pr-3 py-[2px] text-[11px] text-[#0E2240] whitespace-nowrap border-r border-gray-200">
                  {b.branch_name}
                  {b.status === "Greenfield" && <span className="ml-1 text-[8px] uppercase text-[#BF9B30]">GF</span>}
                </td>
                {departments.map((d) => {
                  const c = cells[`${b.branch_id}:${d.dept_id}`];
                  return (
                    <td key={d.dept_id} className="p-[1px]">
                      {c ? (
                        <button
                          data-testid={`heatmap-cell-${b.branch_id}-${d.dept_id}`}
                          onClick={() => onDrill(b, d)}
                          title={`${b.branch_name} · ${d.dept_name}: ${c.a}/${c.s} active/sanctioned (gap ${c.gap})`}
                          className="w-7 h-5 flex items-center justify-center text-[9px] font-semibold text-white tabular-nums hover:opacity-80 transition-opacity duration-150"
                          style={{ backgroundColor: COLORS[c.color] }}
                        >
                          {c.gap !== 0 ? c.gap : ""}
                        </button>
                      ) : (
                        <div
                          className="w-7 h-5 bg-[#F5F6F8] flex items-center justify-center text-[9px] text-gray-300"
                          title={`${b.branch_name} · ${d.dept_name}: no sanction / no headcount`}
                        >
                          –
                        </div>
                      )}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="flex flex-wrap items-center gap-4 mt-2" data-testid="heatmap-legend">
        {LEGEND.map(([k, label]) => (
          <span key={k} className="flex items-center gap-1.5 text-[11px] text-[#6B7280]">
            <span className="w-3 h-3 inline-block rounded-[2px]" style={{ backgroundColor: COLORS[k] }} />
            {label}
          </span>
        ))}
        <span className="text-[11px] text-[#6B7280]">Cell number = gap (sanctioned − active). Click any cell to drill down.</span>
      </div>
    </div>
  );
}
